"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[287],{

/***/ 4287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(727);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7627);
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5585);







function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var PostListing = function(param) {
    var post = param.post;
    var ref, ref1;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("embla__slide", "relative", "mb-4", "md:mb-0", "md:mr-[20px]", "w-full", "flex-[0_0_100%]", "md:flex-[0_0_calc(33.33333333%-12.5px)]"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("block", "w-full", "h-full"),
            href: post.link,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("card", "bg-white", "rounded-[3px]", "overflow-hidden", "h-full", "flex", "flex-col"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("photo", "aspect-video", "relative", "border-b", "border-b-yellow", "border-b-[5px]"),
                        children: (post === null || post === void 0 ? void 0 : (ref = post.media) === null || ref === void 0 ? void 0 : (ref1 = ref.$) === null || ref1 === void 0 ? void 0 : ref1.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                            src: post.media.$.url,
                            alt: post.title,
                            layout: "fill",
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("title", "text-large", "font-sansRegular", "mb-10", "p-2"),
                        children: post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-xs-mobile", "md:text-xs", "font-sansRegular", "uppercase", "p-2", "mt-auto"),
                        children: [
                            "Read More",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("long-arrow"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    name: "LongArrow",
                                    color: "#000000",
                                    viewBox: "0 0 47 13"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
var ArticleListing = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data;
    var sectionTitle = data.sectionTitle, dwellRssUrl = data.dwellRssUrl, backgroundColor = data.backgroundColor, rssPosts = data.rssPosts;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(rssPosts), posts = ref[0], setPosts = ref[1];
    var ref2 = _slicedToArray((0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        align: "start",
        loop: true
    }), 2), viewportRef = ref2[0], embla = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), prevBtnEnabled = ref3[0], setPrevBtnEnabled = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), nextBtnEnabled = ref4[0], setNextBtnEnabled = ref4[1];
    var scrollPrev = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return embla && embla.scrollPrev();
    }, [
        embla
    ]);
    var scrollNext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        return embla && embla.scrollNext();
    }, [
        embla
    ]);
    var onSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!embla) return;
        setPrevBtnEnabled(embla.canScrollPrev());
        setNextBtnEnabled(embla.canScrollNext());
    }, [
        embla
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!embla) return;
        embla.on("select", onSelect);
        onSelect();
    }, [
        embla,
        onSelect
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("article-listing", "px-gutter", "bg-".concat(backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.value), "relative", "z-0"),
        "data-theme": backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.title.toLowerCase(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "grid-cols-4", "md:grid-cols-20", "site-container"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-span-4 block w-full md:col-span-18 md:col-start-2",
                    children: sectionTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-lg-2-mobile", "md:text-lg-2", "mb-8"),
                        children: sectionTitle
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "grid-cols-4", "md:grid-cols-20", "site-container"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-4", "block", "md:hidden"),
                        children: posts.slice(0, 3).map(function(post, idx) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PostListing, {
                                post: post
                            }, idx);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-1", "col-start-1", "hidden", "md:flex", "place-content-center"),
                        children: posts && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-[40px]"),
                            onClick: function() {
                                return scrollPrev();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                name: "CarouselLeft",
                                viewBox: "0 0 64 64",
                                color: "#292929"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-18 col-start-2",
                        children: posts && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("posts-carousel", "hidden", "md:flex", "embla", "w-full", "overflow-hidden"),
                            ref: viewportRef,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex", "w-full", "embla__container"),
                                children: posts.map(function(post, idx) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PostListing, {
                                        post: post
                                    }, idx);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-1", "col-start-20", "hidden", "md:flex", "place-content-center"),
                        children: posts && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-[40px]"),
                            onClick: function() {
                                return scrollNext();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                name: "CarouselRight",
                                viewBox: "0 0 64 64",
                                color: "#292929"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (ArticleListing);


/***/ })

}]);